const getChromeVersion = () => {
  let pieces: null | any[] = navigator.userAgent.match(/Chrom(?:e|ium)\/([0-9]+)\.([0-9]+)\.([0-9]+)\.([0-9]+)/);
  if (pieces === null || pieces.length !== 5) {
    return undefined;
  }

  pieces = pieces.map(piece => parseInt(piece, 10));

  return pieces[1];
};

const getEdgeVersion = () => {
  let pieces: null | any[] = navigator.userAgent.match(/Ed(?:g)\/([0-9]+)\.([0-9]+)\.([0-9]+)/);
  if (pieces == null || pieces.length < 4) {
    return undefined;
  }
  pieces = pieces.map(piece => parseInt(piece, 10));
  return pieces[1];
};

export const isShowWebRtc = () => {
  const ua = navigator.userAgent;
  const isChrome = /(?:Chrome|CriOS)/.test(ua) && !(ua.indexOf('Edg') > -1);
  const isEdge = ua.indexOf('Edg') > -1;
  let isShow = false;

  if (isChrome) {
    const chromeVersion = getChromeVersion();

    if (chromeVersion && chromeVersion >= 72) {
      isShow = true;
    }
  } else if (isEdge) {
    const edgeVersion = getEdgeVersion();

    if (edgeVersion && edgeVersion >= 80) {
      isShow = true;
    }
  }

  return isShow;
};
